// Used to require that the user select a variant before being able to add to bag
function setupVariantSelects() {
  const url = new URL(window.location.href);
  const hasVariant = url.searchParams.has('variant');

  if (hasVariant) return;

  // Find all variant-selects elements that require selection
  const variantSelects = document.querySelectorAll('variant-selects[data-require-selection="true"]');

  variantSelects.forEach((variantSelect) => {
    // Only clear size-related radio buttons
    const fieldset = this.findSizeorAmountFieldset(variantSelect);

    if (fieldset) {
      // Clear only size radio button selections
      fieldset.querySelectorAll('input[type="radio"]').forEach((radio) => {
        radio.checked = false;
      });

      // Clear the selected value text for size
      fieldset.querySelector('[data-selected-value]').textContent = '';

      // Find the associated product form
      const section = variantSelect.dataset.section;
      const productForm = document.querySelector(`product-form[data-section-id="${section}"]`);

      if (productForm) {
        // Clear the variant ID input
        const variantInput = productForm.querySelector('input[name="id"]');
        if (variantInput) {
          variantInput.value = '';
        }

        // Trigger a variant change event to update the UI
        document.dispatchEvent(
          new CustomEvent('variant:change', {
            detail: {
              variant: null,
            },
          }),
        );
      }
    }

    // Mark all color swatches as available initially
    const colorOptions = variantSelect.querySelectorAll('input[name^="color" i]');
    if (colorOptions) {
      colorOptions.forEach((option) => {
        const label = variantSelect.querySelector(`label[for="${option.id}"]`);
        if (option.dataset.productAvailable && label?.classList.contains('unavailable')) {
          label.classList.remove('unavailable');
        }
      });
    }
  });
}

// Helper method to find the size fieldset
function findSizeorAmountFieldset(variantSelect) {
  // Look for fieldsets with legends containing "Size" or "size"
  const fieldsets = variantSelect.querySelectorAll('fieldset.product-form-input');

  for (const fieldset of fieldsets) {
    const legend = fieldset.querySelector('legend');
    if (
      legend &&
      (legend.textContent.toLowerCase().includes('size') || legend.textContent.toLowerCase().includes('amount'))
    ) {
      return fieldset;
    }
  }

  // If no specific size fieldset is found, return null
  return null;
}

setupVariantSelects();
